export function AiCreditToastBridge() {
  // Credit warnings are handled by ApiErrorToastBridge after user-triggered
  // AI calls. Do not poll /health on boot; passive checks created no-click
  // provider toasts on otherwise idle app launches.
  return null;
}
